module.exports = {"id":"208450","name":"Andreas Pereira","rating":"79","photo":"./data/images/photos/2/208450.png","club":{"name":"Valence CF","logo":"./data/images/clubs/ValenceCF.png"},"positions":["MG","MD","MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndreasPereira0.json
// module id = 379
// module chunks = 0